import { reactive } from 'vue'
import type { ISidebarModule, IMenu } from '@fondationcss/ui'
import { getCustomSdk } from '@/sdk'

const boardItems: IMenu[] = reactive([
  { title: 'Tableaux', icon: 'lightbulb', to: '/boards' },
])

export const sidebarItems: ISidebarModule[] = reactive([
  {
    items: boardItems,
  },
  {
    module: 'Heuriqa',
    permissions: ['Modérateur', 'Administrateur'],
    items: [
      { title: 'Administration', icon: 'gear', to: '/admin' },
    ],
  },
])

export async function refreshSidebarBoards() {
  const sdk = getCustomSdk()
  const boards = await sdk.getBoards()
  boardItems.length = 0
  for (const board of boards) {
    const item: IMenu = {
      title: board.name,
      to: `/boards/${board.slug}`,
    }
    if (board.logoUrl) {
      item.logo = sdk.resolveApiUrl(board.logoUrl)
      item.logoAlt = board.name
    } else {
      item.icon = 'lightbulb'
    }
    boardItems.push(item)
  }
}
